import {SimpleTitle} from "../styles";
import React, {FC, Fragment, useMemo} from "react";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { Endpoints } from "@brg/api";

export enum NotificationLinkType {
    OPEN_PAGE="openPage",
    DOWNLOAD_FILE="downloadFile"
}

enum NotificationLinkEntityType {
    CALENDAR="calendar",
    CALENDAR_PDF="calendarpdf",
    CARD="card",
    CARD_PDF="cardpdf",
    PAGE_LINK="pageLink"
}

interface NotificationDivider {
    link: string
    entityId: string
    type: NotificationLinkType
    entityType: NotificationLinkEntityType
    part: string
}

const LINK_PLACEHOLDER = "{{LINK}}"

const LINK_PART_TEMPLATES = {
    [NotificationLinkEntityType.CALENDAR]: `${process.env.REACT_APP_URL_GALLERY}/365/calendar/preview/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.CALENDAR_PDF]: `${process.env.REACT_APP_URL_GALLERY}/card/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.CARD]: `${process.env.REACT_APP_URL_GALLERY}/card/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.CARD_PDF]: `${process.env.REACT_APP_URL_GALLERY}/card/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.PAGE_LINK]: LINK_PLACEHOLDER,
}

export const NotificationSendFile: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const { error } = useToasts()
    const { t, i18n } = useTranslation()
    const toasts = useToasts()

    const [ fileData ] = actions;
    const { description, files, textParts, entityName } = fileData;

    const dividers: NotificationDivider[] = useMemo(() => {
        const dividersArr: NotificationDivider[] = [];

        const partsList = Array.isArray(textParts) ? textParts : [];
        partsList.forEach((divider: any) => {
            const innerParts = Array.isArray(divider.parts) ? divider.parts : [];
            innerParts.forEach((partObj: any) => {
                const part = Object.values(partObj || {}).join("");
                dividersArr.push({
                    part,
                    link: divider.link,
                    entityId: divider.entityId,
                    entityType: divider.entityType,
                    type: divider.linkType
                });
            });
        });

        return dividersArr;
    }, [textParts]);

    const dividedText: string[] = useMemo(() => {
        let newDesc = description

        dividers.forEach((divider: NotificationDivider) => {
            const part = divider.part
            newDesc = newDesc.replace(part, `|${part}|`)
        })

        return newDesc.split("|")
    }, [description, dividers]) 

    const handleDownload = (uploadUrl: string) => {
        toasts.info(t('print_project_save'))
      fetch(uploadUrl, { method: 'GET' })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `${entityName}.pdf`
                document.body.appendChild(a);
                a.click();
                //@ts-ignore
                a = undefined
            })
            .catch((err: any) => {
                console.log('print_error_message', err)
                error(t('print_error_message'))
            })
    }

    return <SimpleTitle>
        {dividedText.map((textPart, partId) => {
            const actionPart = dividers.find(div => div.part === textPart)
            if (!actionPart) return <Fragment key={partId}>{textPart}</Fragment>

            if (actionPart.type === NotificationLinkType.OPEN_PAGE) {
                const link = LINK_PART_TEMPLATES[actionPart.entityType]?.replace(LINK_PLACEHOLDER, actionPart.entityId)
                return <a href={link} target="_blank" key={partId}>{textPart}</a>
            }

            if (actionPart.type === NotificationLinkType.DOWNLOAD_FILE) {
                const uploadUrl = `${Endpoints.files}/${actionPart?.link}`
                return <a onClick={() => handleDownload(uploadUrl)} key={partId}>{textPart}</a>
            }
        })}
    </SimpleTitle>
}import {SimpleTitle} from "../styles";
import React, {FC, Fragment, useMemo} from "react";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { Endpoints } from "@brg/api";

export enum NotificationLinkType {
    OPEN_PAGE="openPage",
    DOWNLOAD_FILE="downloadFile"
}

enum NotificationLinkEntityType {
    CALENDAR="calendar",
    CALENDAR_PDF="calendarpdf",
    CARD="card",
    CARD_PDF="cardpdf",
    PAGE_LINK="pageLink"
}

interface NotificationDivider {
    link: string
    entityId: string
    type: NotificationLinkType
    entityType: NotificationLinkEntityType
    part: string
}

const LINK_PLACEHOLDER = "{{LINK}}"

const LINK_PART_TEMPLATES = {
    [NotificationLinkEntityType.CALENDAR]: `${process.env.REACT_APP_URL_GALLERY}/365/calendar/preview/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.CALENDAR_PDF]: `${process.env.REACT_APP_URL_GALLERY}/card/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.CARD]: `${process.env.REACT_APP_URL_GALLERY}/card/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.CARD_PDF]: `${process.env.REACT_APP_URL_GALLERY}/card/${LINK_PLACEHOLDER}`,
    [NotificationLinkEntityType.PAGE_LINK]: LINK_PLACEHOLDER,
}

export const NotificationSendFile: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const { error } = useToasts()
    const { t, i18n } = useTranslation()
    const toasts = useToasts()

    const [ fileData ] = actions;
    const { description, files, textParts, entityName } = fileData;

    const dividers: NotificationDivider[] = useMemo(() => {
        const dividersArr: NotificationDivider[] = [];

        const partsList = Array.isArray(textParts) ? textParts : [];
        partsList.forEach((divider: any) => {
            const innerParts = Array.isArray(divider.parts) ? divider.parts : [];
            innerParts.forEach((partObj: any) => {
                const part = Object.values(partObj || {}).join("");
                dividersArr.push({
                    part,
                    link: divider.link,
                    entityId: divider.entityId,
                    entityType: divider.entityType,
                    type: divider.linkType
                });
            });
        });

        return dividersArr;
    }, [textParts]);

    const dividedText: string[] = useMemo(() => {
        let newDesc = description

        dividers.forEach((divider: NotificationDivider) => {
            const part = divider.part
            newDesc = newDesc.replace(part, `|${part}|`)
        })

        return newDesc.split("|")
    }, [description, dividers]) 

    const handleDownload = (uploadUrl: string) => {
        toasts.info(t('print_project_save'))
      fetch(uploadUrl, { method: 'GET' })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `${entityName}.pdf`
                document.body.appendChild(a);
                a.click();
                //@ts-ignore
                a = undefined
            })
            .catch((err: any) => {
                console.log('print_error_message', err)
                error(t('print_error_message'))
            })
    }

    return <SimpleTitle>
        {dividedText.map((textPart, partId) => {
            const actionPart = dividers.find(div => div.part === textPart)
            if (!actionPart) return <Fragment key={partId}>{textPart}</Fragment>

            if (actionPart.type === NotificationLinkType.OPEN_PAGE) {
                const link = LINK_PART_TEMPLATES[actionPart.entityType]?.replace(LINK_PLACEHOLDER, actionPart.entityId)
                return <a href={link} target="_blank" key={partId}>{textPart}</a>
            }

            if (actionPart.type === NotificationLinkType.DOWNLOAD_FILE) {
                const uploadUrl = `${Endpoints.files}/${actionPart?.link}`
                return <a onClick={() => handleDownload(uploadUrl)} key={partId}>{textPart}</a>
            }
        })}
    </SimpleTitle>
}